import axios from 'axios';
import { hideLoading } from '../../../components/ui/loading/loading.reducer';
import { getCompany } from '../../../core/session-storage/session-storage.service';
import { environment } from '../../../environments/environment';
import { showError } from '../../error/error.reducer';

/**
 * Formats a date string to a localized format based on language
 */
export const formatDateByLanguage = (dateStr: string | undefined, language: string = 'ES'): string => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    
    // Verifica si la fecha es válida
    if (isNaN(date.getTime())) {
      console.warn('Fecha inválida:', dateStr);
      return dateStr;
    }
    
    // Configurar según idioma
    const options: Intl.DateTimeFormatOptions = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    
    const languageMap: { [key: string]: string } = {
      'ES': 'es-ES',
      'EN': 'en-US',
      'FR': 'fr-FR',
      'DE': 'de-DE',
      'IT': 'it-IT',
      'PT': 'pt-PT'
    };
    
    const locale = languageMap[language.toUpperCase()] || 'es-ES';
    
    //console.log('📅 Formateando fecha:', { dateStr, language, locale, dateObj: date });
    const formatted = new Intl.DateTimeFormat(locale, options).format(date);
    //console.log('📅 Resultado formateado:', formatted);
    
    return formatted;
  } catch (error) {
    console.error('Error al formatear fecha:', error, dateStr);
    return dateStr;
  }
};

/**
 * Maps and enriches delivery data from backend response
 * Ensures all required fields for the confirmation view are available
 */
const mapDeliveryData = (data: any, recordNumber: string, language: string = 'ES'): any => {
  if (!data) {
    console.warn('mapDeliveryData: datos vacíos recibidos');
    return {
      recordNumber: recordNumber,
      requestDate: '',
      fullName: '',
      homeAddress: '',
      postalCode: '',
      locality: '',
      country: '',
      countryName: '',
      phone: '',
      email: '',
      preference: '',
      difficulty: '',
      baggageModel: '',
      baggageSize: '',
      baggageColor: ''
    };
  }

  const mapped = {
    // Delivery address fields
    fullName: data.fullName || data.lastName || '',
    homeAddress: data.homeAddress || data.address || '',
    postalCode: data.postalCode || data.zipCode || '',
    locality: data.locality || data.city || '',
    country: data.country || '',
    countryName: data.countryName || data.country || '',
    phone: data.phone || '',
    email: data.email || '',
    preference: data.preference || data.deliveryPreference || '', // Raw code, will be mapped in component
    difficulty: data.difficulty || data.additionalObservations || '',
    baggageModel: data.baggageModel || data.model || '',
    baggageSize: data.baggageSize || data.size || '',
    baggageColor: data.baggageColor || data.color || '',
    recordNumber: recordNumber,

    // Preserve original data in case needed
    ...data,
    
    requestDate: formatDateByLanguage(data.requestDate || data.createdDate, language)
  };
  
  return mapped;
};

export const getDeliveris = (payload: any, useHistory: any) => {

  const url = environment.endpoints.deliveries + '/' + payload.recordNumber + '/' + payload.pir + '/' + payload.language;
  const companyStorage = getCompany();

  return (dispatch: any, getState: any) => {
    return axios
      .get(url)
      .then((response) => {
        
        if(!response || !response.data || !response.data.data){
          console.log('GET_DELIVERIS :  NO RESPONDIO COMO SE ESPERABA')
          dispatch(hideLoading());
          return mapDeliveryData({}, payload.recordNumber, payload.language);
        }
        // Map and enrich the response data (extract from response.data.data)
        const mappedData = mapDeliveryData(response.data.data, payload.recordNumber, payload.language);
        dispatch(hideLoading());
        return mappedData;
      }).catch((error) => {
        console.error('GET_DELIVERIS ERROR:', error);
        console.error('ERROR RESPONSE:', error.response);
        dispatch(showError({ msg: 'ERROR: USER_SERVICE', redirect: `${companyStorage}/pirs`, codeError: 'ERR000001' }));
        dispatch(hideLoading());
        useHistory.push(`/${companyStorage}/error`);
        return mapDeliveryData({}, payload.recordNumber, payload.language);
      })
  };
};

